import { render, staticRenderFns } from "./CardSelector.vue?vue&type=template&id=3b572eef&"
import script from "./CardSelector.vue?vue&type=script&lang=js&"
export * from "./CardSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports